import { SurveyListItem } from '../api/models/SurveyListItem'
import { Box } from './Box'
import { DeleteIcon } from './icons/DeleteIcon'
import { EyeIcon } from './icons/EyeIcon'
import { PencilIcon } from './icons/PencilIcon'
import { useHistory } from 'react-router-dom'
import { Spinner } from './icons/Spinner'

export function DataTable({
  surveys = [],
  handleCreateSurvey,
  loading = false,
  disabled = false,
}: {
  disabled?: boolean
  loading?: boolean
  surveys?: SurveyListItem[]
  handleCreateSurvey: () => Promise<void>
}) {
  const isDisabled = loading || disabled
  const history = useHistory()
  const headers = ['Survey', 'Status', 'Actions']

  function editSurvey(id: string) {
    history.push(`/surveys/${id}`)
  }

  function showResponses(id: string) {
    history.push(`/responses/${id}`)
  }

  return (
    <Box>
      <div className="overflow-x-auto">
        <table className="min-w-max w-full table-auto">
          <thead>
            <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
              {headers.map(h => (
                <th key={h} className="py-3 px-6 text-left">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="text-gray-600 text-sm font-light">
            {loading ? (
              <tr className="">
                <td
                  colSpan={3}
                  className="py-3 px-6 text-center whitespace-nowrap"
                >
                  <div className="flex justify-center">
                    <Spinner />
                  </div>
                </td>
              </tr>
            ) : null}
            {!loading && surveys.length === 0 ? (
              <tr className="">
                <td
                  colSpan={3}
                  className="py-3 px-6 text-center whitespace-nowrap"
                >
                  No surveys found.{' '}
                  <a
                    onClick={handleCreateSurvey}
                    className="underline text-blue-500 cursor-pointer"
                  >
                    Create one
                  </a>
                </td>
              </tr>
            ) : null}
            {surveys.map(r => (
              <tr
                key={r.url}
                className="border-b border-gray-200 hover:bg-gray-100"
              >
                <td className="py-3 px-6 text-left whitespace-nowrap">
                  <div className="flex items-center">
                    <span className="font-medium">{r.fileName}</span>
                  </div>
                </td>
                <td className="py-3 px-6">
                  <span className="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">
                    Active
                  </span>
                </td>
                <td className="py-3 px-6">
                  <div className="flex item-center">
                    <a
                      onClick={() => showResponses(r.id)}
                      className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110 cursor-pointer"
                    >
                      <EyeIcon />
                    </a>
                    <a
                      onClick={() => editSurvey(r.id)}
                      className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110 cursor-pointer"
                    >
                      <PencilIcon />
                    </a>
                    <div className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110 cursor-pointer">
                      <DeleteIcon />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Box>
  )
}
